import React, { useState } from 'react';
import { Backdrop, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { HtmlTooltip, Typography } from '../../../components/controls';
import { CheckboxBlankCircle, HelpCircleOutline } from "mdi-material-ui";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { green, red } from '@material-ui/core/colors';

export default function MergedCoTicketResult(props) {
    const { resultData, open, onClose } = props;
    const classes = useStyles();

    //const [coTicketResultData, setCoTicketResultData] = useState(data);

    const handleMergedCoTickeClose = () => {
        onClose();
    };
    return (
        <Dialog
            fullWidth={true}
            maxWidth={resultData.hasError ? 'sm' : 'md'}
            open={open}
            onClose={handleMergedCoTickeClose}
            aria-labelledby="form-dialog-title">
            <DialogContent>
                <Box className={clsx('dialog-message', { error: resultData.hasError === true, warning: resultData.hasError === false })}>
                    {resultData.hasError ?
                        <Box mb={1}>
                            <Typography variant="h5" align="center" status="danger">Error</Typography>
                            <Typography variant="subtitle1" align="center" status="danger">The tickets can't be merge for the following reasons</Typography>
                            <List dense="true">
                                {resultData.errors.map((error) => (
                                    <ListItem>
                                       <ListItemText primary={error} />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                        :
                        <Box mb={1}>
                            <Typography variant="h5" align="center" status="success">Co-Ticket Merged </Typography>
                            <Box mb={2}>
                                <Typography variant="subtitle1" align="center" status="success">Co-Ticket has been merged successfully with the following calculations</Typography>
                                </Box>
                            <TableContainer component={Paper}>
                                <Table className={classes.table} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Ticket Id</TableCell>
                                            <TableCell align="right">Weight In</TableCell>
                                            <TableCell align="right">Weight Out</TableCell>
                                            <TableCell align="right">Do Weight</TableCell>
                                            <TableCell align="right" style={{ fontWeight: 800 }}>Net Weight</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {resultData.mergedTickets && resultData.mergedTickets.map((row) => (
                                            <TableRow key={row.ticketId}>
                                                <TableCell component="th" scope="row">
                                                    {row.ticketId}
                                                </TableCell>
                                                <TableCell align="right">{row.weightIn}</TableCell>
                                                <TableCell align="right">{row.weightOut}</TableCell>
                                                <TableCell align="right">{row.vendorDoWeight}</TableCell>
                                                <TableCell align="right" style={{ fontWeight: 800 }}>{row.netWeight}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    }
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleMergedCoTickeClose} variant="contained" color="default">Close</Button>
            </DialogActions>
        </Dialog>
    );
}
const useStyles = makeStyles(theme => ({
    danger: {
        color: red[600],
    },
}));

